import React, { useState } from "react";
import { HowyouHeardJson } from "../modal/howyouheardModal";

const HowYouHeardAboutUs = React.memo((props) => {
  const [checkk, setCheckk] = useState([]);
  const handleChange = (e) => {
    let { value, checked } = e.target;
    let tempcheck = checkk;
    if (checked) {
      tempcheck.push({ name: value });
    } else {
      tempcheck = tempcheck.filter((ck) => ck.name !== value);
    }

    let str = "";
    for (var i = 0; i < tempcheck.length; i++) {
      str += tempcheck[i].name + ",";
    }
    str = str.replace(/,\s*$/, "");
    setCheckk(tempcheck);
    props.handleAchange(str);
  };

  return HowyouHeardJson ? HowyouHeardJson.map((hyh,u) => (
          <div className="form-check" key={u+1}>
            <label className="form-check-label" for={hyh.val}>
              <input
                type="checkbox"
                className="form-check-input"
                value={hyh.val}
                onChange={(e) => handleChange(e)}
              />
              {hyh.val}
            </label>
          </div>
      )) : ""}
  );

export default HowYouHeardAboutUs;
